import DatadogLogger from "@/shared-helpers/datadog-logger.helper";
import { LogType } from "@/types/dataDogLogType";
import { AxiosError } from "axios";
import { ResponseObject } from "@/apps/core-app-onboarding/types/responses";
// import { AndroidInterface } from "@/apps/core-app-onboarding/services/android.service";
// declare const Android: AndroidInterface;

export const ERROR_CODES = {
  START_SESSION_API_ERROR: 1001,
  START_SESSION_NETWORK_ERROR: 1002,
  LOG_TRANSITION_NETWORK_ERROR: 1003,
  LOG_TRANSITION_API_ERROR: 1004,
  GET_INCODE_URL_API_ERROR: 1005,
  GET_INCODE_URL_NETWORK_ERROR: 1006,
  GET_INCODE_STATUS_API_ERROR: 1007,
  GET_INCODE_STATUS_NETWORK_ERROR: 1008,
  CLOSE_SESSION_API_ERROR: 1009,
  CLOSE_SESSION_NETWORK_ERROR: 1010,
  VALIDATE_CURP_API_ERROR: 1011,
  VALIDATE_CURP_NETWORK_ERROR: 1012,
  CREDIT_PULL_API_ERROR: 1013,
  CREDIT_PULL_NETWORK_ERROR: 1014,
  PERMISSIONS_NETWORK_ERROR: 1015,
  CURP_CHALLENGE_API_ERROR: 2001,
  CURP_CHALLENGE_NETWORK_ERROR: 2002,
};

export class ErrorHandler {
  static logNetworkError(error: AxiosError, errorCode: number): void {
    console.error(error);
    const errorName = Object.keys(ERROR_CODES).find(
      (key) => ERROR_CODES[key] === errorCode
    );
    const responseData = error?.response?.data;
    let errorMsg: string;
    let context = {};
    if (responseData) {
      errorMsg = `CoreApp Onboarding Error: ${errorName}[${errorCode}] - ${responseData.message}`;
      context = responseData.data;
    } else {
      errorMsg = `CoreApp Onboarding Error: ${errorName}[${errorCode}] - ${error.message}`;
      context = error;
    }
    const deviceTag = "";
    DatadogLogger.Log(
      errorMsg,
      {
        ...context,
        deviceTag,
        errorCode,
        errorName,
      },
      LogType.ERROR
    );
  }

  static logAPIError(response: ResponseObject, errorCode: number): void {
    console.error(response.error);
    const errorName = Object.keys(ERROR_CODES).find(
      (key) => ERROR_CODES[key] === errorCode
    );
    const errorMsg = `CoreApp Onboarding Error: [${errorCode}] - ${response?.error}`;
    const deviceTag = "";
    DatadogLogger.Log(
      errorMsg,
      {
        ...response,
        deviceTag,
        errorCode,
        errorName,
      },
      LogType.ERROR
    );
  }
}
